import { useState } from "react";
import { CheckCircle2, Copy, RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function AiVersions({ wu, locked, onUse, onRegenerate, regenerating }) {
  const [confirm, setConfirm] = useState(null);
  const sel = Number(wu?.selected_version) || null;
  const final = wu?.final_edited || "";
  const versions = [1, 2, 3].filter((n) => (wu?.[`ai_version_${n}`] || "").trim());
  if (!versions.length) return null;

  const use = (n) => {
    const text = wu[`ai_version_${n}`];
    if (final.trim() && final !== text) setConfirm(n);
    else onUse(n, text);
  };

  return (
    <div data-testid="ai-versions" className="space-y-3">
      {versions.map((n) => {
        const text = wu[`ai_version_${n}`];
        const isSel = sel === n;
        const edited = isSel && final !== text;
        return (
          <div key={n} data-testid={`ai-version-${n}`} className={`rounded-xl border p-3 transition-colors duration-150 ${isSel ? "border-amber-800 bg-amber-50 ring-1 ring-amber-800" : "border-stone-200 bg-stone-50"}`}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <div className="text-[11px] uppercase tracking-wider text-amber-800 font-semibold">AI Version {n}</div>
              {isSel && (
                <span data-testid={`ai-version-selected-${n}`} className="inline-flex items-center gap-1 rounded-full bg-amber-800 text-white text-[11px] font-bold px-2 py-0.5">
                  <CheckCircle2 className="h-3.5 w-3.5" />{edited ? "Selected (edited)" : "Selected"}
                </span>
              )}
            </div>
            <p className="text-sm text-stone-700 whitespace-pre-wrap">{text}</p>
            {!locked && (
              confirm === n ? (
                <div data-testid={`ai-version-confirm-${n}`} className="mt-3 rounded-lg border border-amber-300 bg-white p-3 text-sm text-amber-900">
                  Replace your current Final Write-Up?
                  <div className="mt-2 flex flex-wrap gap-2">
                    <Button data-testid={`ai-version-confirm-yes-${n}`} onClick={() => { setConfirm(null); onUse(n, text); }} className="h-10 rounded-full bg-amber-800 hover:bg-amber-900 text-white">Replace</Button>
                    <Button data-testid={`ai-version-confirm-no-${n}`} variant="outline" onClick={() => setConfirm(null)} className="h-10 rounded-full">Keep current</Button>
                  </div>
                </div>
              ) : (
                <Button data-testid={`use-ai-version-${n}`} variant={isSel ? "outline" : "default"} onClick={() => use(n)}
                  className={`mt-3 w-full sm:w-auto h-11 rounded-full ${isSel ? "border-amber-800 text-amber-800" : "bg-amber-800 hover:bg-amber-900 text-white"}`}>
                  <Copy className="h-4 w-4 mr-2" />{isSel ? "Use This Version Again" : "Use This Version"}
                </Button>
              )
            )}
          </div>
        );
      })}
      {!locked && (
        <Button data-testid="regenerate-writeups-button" variant="outline" onClick={onRegenerate} disabled={regenerating}
          className="w-full sm:w-auto h-11 rounded-full border-amber-800 text-amber-800 hover:bg-amber-50">
          {regenerating ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-2" />}Regenerate 3 New Versions
        </Button>
      )}
    </div>
  );
}
